/**
 * 全局axios配置
 */
import axios from '@tkit/ajax/lib/axios';
import intl from '@/internationalzation/intl';
import { AjaxCancelCode } from '@tkit/ajax';
import { Message } from '@docs/kd-d2c-components';
import useUserInfo from '../stores/userModel';
// import { AxiosError, AxiosResponse } from 'axios';

const getResponseCode = (response: any) => {
  if (
    response.config?.url?.startsWith(
      '/velcro/webapp/api/message-label/export-file',
    )
  ) {
    if (response.data?.message === undefined) {
      return 0;
    } else if (response.data?.message?.length > 0) {
      return 1;
    } else {
      return 1;
    }
  } else if (
    response.config?.url?.startsWith('/claw/ops/api/dashboard') ||
    response.config?.url?.startsWith('/claw/ops/api/sandbox/kill') ||
    response.config?.url?.startsWith('/claw/ops/api/sandbox/user')
  ) {
    if (response.data?.message === undefined) {
      return 0;
    } else if (response.data?.message?.length > 0) {
      return 1;
    } else {
      return 1;
    }
  } else {
    return response.config?.url?.startsWith('/api/connFlow')
      ? Number(response.data.code)
      : response.data.status;
  }
};
function toastError(msg: string) {
  if (useUserInfo.getState().userInfoLoaded) {
    Message.error({
      key: 'api-error',
      message: msg || intl.t('调用失败1'),
      style: {
        wordBreak: 'break-word',
      },
    });
  }
}
export function initApiInterceptor() {
  axios.interceptors.request.use(function (config) {
    if (config && config.method === 'get') {
      config.headers['Cache-Control'] = 'no-cache';
    }

    // 非线上环境可以响应testUser
    if (location.host.indexOf('corp.kuaishou.com') < 0) {
      const params = new URL(location.href).searchParams;
      // 617119669622677576
      const testUser = params.get('testUser');
      if (testUser) {
        config.url = `${config.url}${config.url?.includes('?') ? '&' : '?'}testUser=${testUser}`;
      }
    }
    return config;
  });
  axios.interceptors.response.use(
    (response) => {
      // 没有对应群组权限
      if ([140002].includes(getResponseCode(response))) {
        location.href = '/no-auth';
        return response;
      }
      if (
        getResponseCode(response) !== 0 &&
        // @ts-ignore
        !response?.config?.silence &&
        !response.config.headers?.disabledToast
      ) {
        toastError(response.data.message || intl.t('调用失败2'));
      }
      return response;
    },
    (error) => {
      const response = error.response;
      console.log('error', error, response);
      // 处理主动取消请求的情况
      if (error?.message?.code === AjaxCancelCode) {
        return Promise.reject(error);
      }
      if (error.response?.status === 401 && !response.config.silence) {
        // 接口返回 401
        toastError(response.data.message || intl.t('鉴权失败'));
      } else if (!error?.config?.silence) {
        // 服务端非 200 的错误
        if (response.config?.url?.startsWith('/claw/ops/api/dashboard')) {
          return;
        }
        toastError(
          response?.data?.message ||
            response?.data?.error?.message ||
            intl.t('调用失败3'),
        );
      }
      return Promise.reject(error);
    },
  );
}
